declare global {
  interface RegExpConstructor {
    escape: (string: string) => string;
  }
}

RegExp.escape = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
